import React, { useCallback, useEffect, useState } from 'react';
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from 'recharts';
import SoloShell from './SoloShell';
import { api, formatDateTime } from './api';
import './BuzzerSolo.css';

export default function BuzzerSoloAnalyticsPage() {
  const [summary, setSummary] = useState(null);
  const [trend, setTrend] = useState([]);
  const [comments, setComments] = useState([]);
  const [message, setMessage] = useState('');

  const load = useCallback(async () => {
    try {
      const [summaryRes, trendRes, commentsRes] = await Promise.all([
        api.get('/buzzersolo/analytics/summary'),
        api.get('/buzzersolo/analytics/ratings-trend'),
        api.get('/buzzersolo/analytics/comments'),
      ]);
      setSummary(summaryRes.data);
      setTrend(trendRes.data || []);
      setComments(commentsRes.data || []);
    } catch (error) {
      setMessage(error?.response?.data?.error || 'Failed to load analytics');
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <SoloShell title="Analytics & Feedback" subtitle="Track sittings, service demand, ratings trend and customer comments.">
      {message ? <div className="bsolo-card" style={{ marginBottom: 16 }}>{message}</div> : null}
      {summary && (
        <div className="bsolo-kpis" style={{ marginBottom: 18 }}>
          <div className="bsolo-kpi"><div className="bsolo-kpi-label">Sittings</div><div className="bsolo-kpi-value">{summary.sittings}</div></div>
          <div className="bsolo-kpi"><div className="bsolo-kpi-label">Service calls</div><div className="bsolo-kpi-value">{summary.serviceCalls}</div></div>
          <div className="bsolo-kpi"><div className="bsolo-kpi-label">Feedback</div><div className="bsolo-kpi-value">{summary.feedbackCount}</div></div>
          <div className="bsolo-kpi"><div className="bsolo-kpi-label">Avg rating</div><div className="bsolo-kpi-value">{summary.averageRating || '-'}</div></div>
          <div className="bsolo-kpi"><div className="bsolo-kpi-label">Emails</div><div className="bsolo-kpi-value">{summary.emailsCollected}</div></div>
        </div>
      )}

      <div className="bsolo-grid cols-2">
        <div className="bsolo-panel">
          <h3 style={{ marginTop: 0 }}>Rating trend</h3>
          <div style={{ width: '100%', height: 280 }}>
            <ResponsiveContainer>
              <LineChart data={trend}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="day" />
                <YAxis domain={[0, 5]} />
                <Tooltip />
                <Line type="monotone" dataKey="average_rating" strokeWidth={3} dot />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bsolo-panel">
          <h3 style={{ marginTop: 0 }}>Comments</h3>
          <div className="bsolo-list">
            {comments.map((item) => (
              <div key={item.id} className="bsolo-comment">
                <div className="bsolo-row" style={{ justifyContent: 'space-between' }}>
                  <strong>Tables {item.table_numbers}</strong>
                  <span className="bsolo-meta">{item.average_rating}/5</span>
                </div>
                <div style={{ marginTop: 8 }}>{item.comment}</div>
                <div className="bsolo-meta" style={{ marginTop: 8 }}>{formatDateTime(item.submitted_at)} {item.email ? `• ${item.email}` : ''}</div>
              </div>
            ))}
            {!comments.length && <div className="bsolo-empty">No comments yet.</div>}
          </div>
        </div>
      </div>
    </SoloShell>
  );
}
